export const enum CarrierCodes {
  HAPAG_LLOYD = "HLCU",
  MAERSK = "MAEU",
  MSC = "MSCU",
  CMA_CGM = "CMDU",
  EVERGREEN = "EGLV",
  YANG_MING = "YMLU",
  OOCL = "OOLU",
  PIL = "PILU",
  ANL = "ANNU",
  COSCO = "COSU",
  ONE = "ONEY",
}
